export function healthVisual(status) {
  if (status === "bad") {
    return {
      label: "STÖRUNG",
      fg: "#dc2626",
      bg: "rgba(220,38,38,0.14)",
      border: "rgba(220,38,38,0.28)",
    };
  }
  if (status === "warn") {
    return {
      label: "EINGESCHRÄNKT",
      fg: "#b45309",
      bg: "rgba(217,119,6,0.14)",
      border: "rgba(217,119,6,0.28)",
    };
  }
  return {
    label: "IN ORDNUNG",
    fg: "#16a34a",
    bg: "rgba(22,163,74,0.12)",
    border: "rgba(22,163,74,0.22)",
  };
}
